export const startTracking = 'TRACKING_START';
export const requestTracking = 'TRACKING_REQUEST';

export const completeTracking = 'TRACKING_COMPLETE';
export const trackingError = 'TRACKING_ERROR';
